module.exports = __webpack_public_path__ + "static/media/btn_owl.562185f1.png";